import "core-js/modules/es6.function.name";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import * as types from './types';
import { fetchCustomizable } from '~/services/customizable';
export default {
  fetchConfigurator: function fetchConfigurator(_ref, _ref2) {
    var _this = this;

    var commit = _ref.commit;
    var model = _ref2.model;
    var configuration = fetchCustomizable(this, model);
    var base = import('~/api/configurator/config.json');
    Promise.all([configuration, base]).then(function (values) {
      if (!values[0].status) {
        var currentLocale = _this.state.i18n.currentLocale;
        var urlRedirect = values[1].details.backUrl;

        _this.app.context.redirect("/".concat(currentLocale.market, "/").concat(currentLocale.language, "/e/").concat(urlRedirect) || '/');
      }

      var _values$0$payload = values[0].payload,
          options = _values$0$payload.options,
          price = _values$0$payload.price,
          information = _objectWithoutProperties(_values$0$payload, ["options", "price"]);

      commit(types.SET_DEFAULT_CUSTOMIZABLE, {
        options: options,
        price: price,
        model: model,
        information: _objectSpread({}, information, values[1].details)
      });
      commit(types.SET_OPTIONS, options.map(function (option) {
        return _objectSpread({}, option, {
          config: values[1].config[option.name]
        });
      }));
    }).catch(function (error) {
      console.log(error);
    });
  }
};